import React from "react";
import {StockStatusBase} from "./StockStatusBase";

export const StockStatusHU = () => {
    const translations = {
        lastProduct: 'Utolsó darab raktáron',
        stockStatuses: {
            'In stoc': 'Raktáron',
            'Stoc limitat': 'Korlátozott készlet',
            'La comanda': 'Rendelésre',
            'La furnizor': 'Beszállítónál',
            'In stoc furnizor': 'Beszállítói készleten',
            'Stoc extern cu livrare rapida': 'Külső készlet gyors szállítással',
            'Rezervat': 'Foglalt'
        }
    };

    const getStockValue = (status: string) => {
        switch (status) {
            case 'Raktáron':
                return 'Több mint 5 darab van raktáron.';
            case 'Korlátozott készlet':
                return 'Kevesebb mint 5 darab van raktáron.';
            case 'Utolsó darab raktáron':
                return 'A termék a Raktár fizikai készletében van.';
            case 'Rendelésre':
            case 'Beszállítónál':
            case 'Beszállítói készleten':
            case 'Külső készlet gyors szállítással':
                return 'A termék nem elérhető a Raktár készletében, de lehet, hogy megtalálható a beszállító raktárában. ' +
                    'Ha megrendelést regisztrál erre a termékre, értékesítési tanácsadóink egyike ellenőrzi ' +
                    'a termék elérhetőségét a beszállítónál, és a lehető legrövidebb időn belül felveszi Önnel a kapcsolatot.';
            case 'Foglalt':
                return 'A termék a Raktár fizikai készletében van, de foglalt egy ügyfél számára. ' +
                    'Ha érdekli, kérjük, vegye fel velünk a kapcsolatot, hogy ellenőrizzük, a foglalás még aktuális-e.';
            default:
                return '';
        }
    }

    return <StockStatusBase getStockValue={getStockValue} translations={translations}/>;
}
